// extracted by mini-css-extract-plugin
export default {"button":"fyPKRT1VB9oggtRbh7i0","highlight":"pykxwE15Q98ULcRLVXIw"};